import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import PropertyMetricWidget from '../home/widgets/property'

function ListEstateAssets() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m9'>
                {/* <div className='container'> */}
                
                <PropertyMetricWidget/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default ListEstateAssets